import { Component, OnDestroy, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/shared/auth/auth.service';
@Component({
  selector: 'app-2-columns-layout',
  templateUrl: './2-columns-layout.component.html',
  styleUrls: ['./2-columns-layout.component.scss']
})
export class TwoColumnsLayoutComponent implements OnDestroy {
  showmenu: boolean = false;
  constructor(private renderer: Renderer2,public authService:AuthService,private router:Router) {
    this.renderer.addClass(document.body, '2-columns');
    this.renderer.setAttribute(document.body, 'data-col', '2-columns');
   }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, '2-columns');
    // this.renderer.removeAttribute(document.body, 'data-col');
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/2-columns-layout/2-columns-layout.component.ts